import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_APPLICANTDOCUMENT,
  DELETE_APPLICANTDOCUMENT,
  UPDATE_APPLICANTDOCUMENT,
  ADD_NEW_APPLICANTDOCUMENT,
} from "./actionType";

import {
  getApplicantDocumentSuccess,
  getApplicantDocumentFail,
  deleteApplicantDocumentSuccess,
  deleteApplicantDocumentFail,
  updateApplicantDocumentSuccess,
  updateApplicantDocumentFail,
  addApplicantDocumentSuccess,
  addApplicantDocumentFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  getApplicantDocumentApi,
  updateApplicantDocumentApi,
  deleteApplicantDocumentApi,
  addNewApplicantDocumentApi
} from "../../helpers/backend_helper";

function* getApplicantDocument({ payload: applicantDocument }) {
  try {
    const response = yield call(getApplicantDocumentApi, applicantDocument);
    yield put(getApplicantDocumentSuccess(GET_APPLICANTDOCUMENT, response.data));
  } catch (error) {
    yield put(getApplicantDocumentFail(GET_APPLICANTDOCUMENT, error));
  }
}

function* onUpdateApplicantDocument({ payload: applicantDocument }) {
  try {
    const response = yield call(updateApplicantDocumentApi, applicantDocument);
    yield put(updateApplicantDocumentSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(updateApplicantDocumentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteApplicantDocument({ payload: applicantDocument }) {
  try {
    const response = yield call(deleteApplicantDocumentApi, applicantDocument);
    yield put(deleteApplicantDocumentSuccess({ applicantDocument, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteApplicantDocumentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewApplicantDocument({ payload: applicantDocument }) {
  try {
    const response = yield call(addNewApplicantDocumentApi, applicantDocument);
    yield put(addApplicantDocumentSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addApplicantDocumentFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetApplicantDocument() {
  yield takeEvery(GET_APPLICANTDOCUMENT, getApplicantDocument);
}

export function* watchUpdateApplicantDocument() {
  yield takeEvery(UPDATE_APPLICANTDOCUMENT, onUpdateApplicantDocument);
}

export function* watchDeleteApplicantDocument() {
  yield takeEvery(DELETE_APPLICANTDOCUMENT, onDeleteApplicantDocument);
}

export function* watchAddNewApplicantDocument() {
  yield takeEvery(ADD_NEW_APPLICANTDOCUMENT, onAddNewApplicantDocument);
}

function* applicantDocumentSaga() {
  yield all([
    fork(watchGetApplicantDocument),
    fork(watchDeleteApplicantDocument),
    fork(watchUpdateApplicantDocument),
    fork(watchAddNewApplicantDocument)
  ]);
}

export default applicantDocumentSaga;
